// extracted by mini-css-extract-plugin
export default {"container":"Artikler_container__058Qn","placeholder":"Artikler_placeholder__ABv8i","arrow":"Artikler_arrow__64Q4g"};